export class SetNewPasswordForm {
    constructor(private password: string, private token: string) { }
}